import JSEncrypt from 'jsencrypt';
import { apiRequest, persistAccessToken } from './request';

const GRANT_TYPE = 'password';
const CLIENT_ID = 'uaa-web';

export function mapUserInfo(userInfo: any, username: string): API.CurrentUser {
  const roleCode = userInfo?.roleCode;
  const isAdmin = roleCode === 'GUANLIYUAN';
  const isProjectGroup = roleCode === 'XIANGMUZU';

  return {
    id: String(userInfo?.uid || username),
    name: userInfo?.username || userInfo?.name || username,
    officeRank: isAdmin ? 'ADMIN' : isProjectGroup ? 'PM' : 'USER',
    roleLabel: isAdmin ? '管理员' : isProjectGroup ? '项目组' : '用户',
    department:
      userInfo?.organizationName || userInfo?.departmentName || 'BenHealth',
    email: userInfo?.email,
    roleCode,
    raw: userInfo,
  };
}

export async function getPublicKey() {
  return apiRequest('/api/uaa/auth/key', {
    method: 'GET',
    throwOnError: true,
    withAuth: false,
  });
}

export function encryptPassword(password: string, publicKey: string) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  const encrypted = encryptor.encrypt(password);

  if (!encrypted) {
    throw new Error('密码加密失败');
  }

  return encrypted;
}

export async function loginByPassword({
  username,
  password,
  key,
}: {
  username: string;
  password: string;
  key: string;
}) {
  const params = new URLSearchParams({
    username,
    password,
    key,
    grant_type: GRANT_TYPE,
    client_id: CLIENT_ID,
  });

  return apiRequest(`/api/uaa/oauth2/token?${params.toString()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withAuth: false,
  });
}

export async function queryCurrentUser(accessToken?: string) {
  const headers = accessToken
    ? {
        authorization: `bearer ${accessToken}`,
      }
    : undefined;

  return apiRequest('/api/uaa/auth/userinfo', {
    method: 'GET',
    headers,
    throwOnError: true,
  });
}

export function persistLoginToken(token: string) {
  persistAccessToken(token);
}

export function clearLoginToken() {
  persistAccessToken();
}
